//Description : Message panel for both spoc and admin

import React, { useState } from 'react';
import { CampaignSharp, CloseSharp } from '@mui/icons-material';
import { Box, IconButton, Modal, Stack, TextField, Typography, Button, FormControlLabel, Radio, RadioGroup, Chip, FormGroup, Checkbox, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material';
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { InputAdornment } from '@mui/material';
import { FormControl } from '@mui/material';
import Axios from '../../../axios/Axios';
import { useDispatch } from 'react-redux';
import { showSnackbar } from '../../redux/features/appSlice';
import { LoadingButton } from '@mui/lab';
import axios from 'axios';

export const AnnouncementModal = () => {

  const user_id = sessionStorage.getItem("user_id");
  const dispatch = useDispatch();
  const [announcementModalOpen, setAnnouncementModalOpen] = useState(false);
  const [announcementType, setAnnouncementType] = useState("mail");
  const [sendToAllTeachers, setSendToAllTeachers] = useState(false);
  const [toMail, setToMail] = useState("");
  // console.log(toMail);
  const [senderMailIds, setSenderMailIds] = useState([]);
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [suggestMail, setSuggestMail] = React.useState([]);
  const [error, setError] = useState({ toError: false, subjectError: false, messageError: false });
  const [loading, setLoading] = useState(false)
  const [unRegisterEmail, setUnRegisterEmail] = React.useState(false);
  const [unRegisterEmailList, setUnRegisterEmailList] = React.useState([]);
  const [sentUnRegisterEmail, setSentUnRegisterEmail] = React.useState(false)

  // console.log(announcementType, "announcementType");
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    height: "98%",
    bgcolor: 'background.paper',
    border: '2px solid #CED4DA',
    overflowY: 'scroll',
    borderRadius: "5px",
    boxShadow: 24,
    padding: "20px",
  };
  React.useEffect(() => {
    const controller = axios.CancelToken.source();

    const fetchData = async () => {
      try {
        const options = {
          method: "post",
          url: "/announcement/getEmails",
          auth: true,
          data: { email: toMail },
          token: { cancelToken: controller.token }
        };
        const response = await Axios(
          options.method,
          options.url,
          options.auth,
          options.data,
          options.token,
        );
        if (response.status == 200) {
          setSuggestMail(response.data);
        }
        // console.log(response);
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.log(error);
        }
      }
    }
    if (toMail) {
      fetchData();
    }    // for cleanup 
    return () => {
      controller.cancel();
    }

  }, [toMail]);


  async function sendAnnouncement() {

    if (error.toError || error.subjectError || error.messageError) {
      return dispatch(showSnackbar({
        message: "There are errors on your input fields, Please enter a valid information",
        severity: "error"
      }))
    }

    if (announcementType === "mail") {
      if ((!sendToAllTeachers && toMail === "" && senderMailIds.length === 0) || subject === "" || message === "") {
        return dispatch(showSnackbar({
          message: "There are one or more input fields are empty, Please enter a valid information",
          severity: "error"
        }))
      }
    } else {
      if (subject === "" || message === "") {
        return dispatch(showSnackbar({
          message: "There are one or more input fields are empty, Please enter a valid information",
          severity: "error"
        }))
      }

    }



    try {
      setLoading(true);
      let responseData
      if (!sentUnRegisterEmail && announcementType === "mail") {
        responseData = await Axios('post', '/announcement/verifyEmails', true, { emails: senderMailIds.length > 0 ? senderMailIds : [{ emails: toMail }] });

        if (responseData.status === 200 && responseData.data.hasUnRegisteredEmails === true) {
          // console.log('unregister');
          setLoading(false);
          setUnRegisterEmail(true);
          setUnRegisterEmailList(responseData.data.unRegisteredEmils)
          setSentUnRegisterEmail(true)
        } else if (responseData.status === 200 && responseData.data.hasUnRegisteredEmails === false) {
          setSentUnRegisterEmail(true)
          await sendAnnouncementEmailFunction();
        } else if (sentUnRegisterEmail) {
          await sendAnnouncementEmailFunction()
        }
      } else {
        // console.log(sentUnRegisterEmail, 'sentUnRegisterEmail');
        await sendAnnouncementEmailFunction()
      }


    } catch (err) {
      setLoading(false);
      console.log(err);
      dispatch(showSnackbar({
        message: "Failed to send announcement, try again later",
        severity: "error"
      }))
    }
  }

  async function sendAnnouncementEmailFunction() {
    let response
    if (announcementType === "mail") {
      response = await Axios("post", "announcement/add", true, {
        announcement_type: announcementType,
        mail_to: senderMailIds.length > 0 ? senderMailIds : [{ emails: toMail }],
        send_to_all_teachers: sendToAllTeachers,
        subject,
        message,
        user_id
      });
    } else {
      response = await Axios("post", "announcement/sendNotifications", true, {
        announcement_type: announcementType,
        send_to_all_teachers: true,
        subject,
        message: message,
        sent_by: user_id
      });
    }


    if (response.status === 200) {
      dispatch(showSnackbar({
        message: "Announcement sent successfully",
        severity: "success"
      }))
      // window.location.reload();
      setSubject("");
      setMessage("");
      setLoading(false);
    } else {
      // console.log(response);
      dispatch(showSnackbar({
        message: response.data.message,
        severity: "error"
      }))
      setSubject("");
      setMessage("");
      setLoading(false);
    }
  }


  function UnRegisterEmails({ open, onClose, setSentUnRegisterEmail }) {
    return (
      <Dialog open={open} onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ overflowY: "scroll", }}
      >
        <DialogTitle sx={{ color: 'red' }} id="alert-dialog-title">
          {"WARNING !"}
        </DialogTitle>
        <DialogContent dividers="true" sx={{
          overflowY: "scroll",
          width: "420px", // Set your desired width
          height: "150px", // Set your desired height
        }}>
          <DialogContentText id="alert-dialog-description">
            <Typography sx={{ paddingBottom: '10px' }}>Do you want to process the unregister email IDs?</Typography>
            <Typography gutterBottom>
              {unRegisterEmailList.map(mailList => {
                return (
                  <Chip
                    key={mailList}
                    label={mailList}
                    size='small'
                    color='primary'
                  />
                )
              })}
            </Typography>

          </DialogContentText>
        </DialogContent>
        <DialogActions dividers="true">
          <Button onClick={(e) => {
            onClose()
            setSentUnRegisterEmail(false)
          }}>Cancel</Button>
          <Button onClick={(event) => {
            setUnRegisterEmail(false)
            sendAnnouncement(event)
            setSentUnRegisterEmail(false)
          }} autoFocus>
            Proceed
          </Button>
        </DialogActions>
      </Dialog>
    )
  }

  // module close function 

  const closeModule = () => {
    setAnnouncementModalOpen(false);
    setToMail("");
    setSubject("");
    setMessage("");
    setSenderMailIds([]);
    setLoading(false)
    setError(prevState => ({ ...prevState, toError: false }))
  }

  return (
    <>
      <IconButton
        sx={{ color: "white", mr: "16px" }}
        onClick={() => {
          setAnnouncementModalOpen(!announcementModalOpen);
        }}
      >
        <CampaignSharp sx={{ color: "white", fontSize: 30 }} />
      </IconButton>
      <Modal
        open={announcementModalOpen}
        onClose={() => closeModule()}

      >
        <Box sx={style}>
          <Stack direction="row" sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Make Announcement
            </Typography>
            <IconButton onClick={() =>closeModule()}
            >
              <CloseSharp />
            </IconButton>
          </Stack>
          <Stack margin="10px" spacing={3} direction="column">
            <FormControl>
              <Typography>Notification type :</Typography>
              <RadioGroup
                value={announcementType}
                onChange={(e) => setAnnouncementType(e.target.value)}
              >
                <FormControlLabel value="mail" control={<Radio />} label="Mail" />
                <FormControlLabel value="notification" control={<Radio />} label="Push notification" />
              </RadioGroup>
            </FormControl>

            {announcementType === "mail" &&
              <>
                <Box className='mail-chips' sx={senderMailIds.length === 0 ? { display: "none" } : { display: "flex" }}>
                  {senderMailIds.map(mailId => {
                    return (
                      <Chip
                        key={mailId.emails}
                        label={mailId.emails}
                        size='small'
                        color='primary'
                        onDelete={() => {
                          setSenderMailIds((toMails) => toMails.filter((mail) => mail.emails !== mailId.emails))
                        }}
                      />
                    )
                  })}
                </Box>
                {senderMailIds.length === 5 && <Typography variant='subtitle1' color="red" fontSize="12px" component="p">Sender's Mail IDs limit has exceeded</Typography>}

                <Box>
                  <TextField
                    sx={{ '& legend': { display: 'none' }, '& fieldset': { top: 0 } }}
                    fullWidth
                    type="text"
                    variant='outlined'
                    size='small'
                    color='primary'
                    disabled={sendToAllTeachers}
                    error={error.toError}
                    value={toMail}
                    helperText={error.toError && "Please Enter a valid Email ID"}
                    InputProps={{ startAdornment: <InputAdornment position='start'>To : </InputAdornment> }}
                    onChange={(event) => {
                      if (event.target.value.length > 0 && !/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(event.target.value)) {
                        setError(prevState => ({ ...prevState, toError: true }))
                        setToMail(event.target.value)
                      } else {
                        setError(prevState => ({ ...prevState, toError: false }))
                        setToMail(event.target.value)
                      }
                    }}
                    onKeyPress={(event) => {
                      if (!error.toError && event.key === "Enter" && senderMailIds.length < 5) {
                        setSenderMailIds(prevState => {
                          return [...prevState, { emails: toMail }]
                        })
                        setToMail("");
                      }
                    }}
                  />
                  <FormGroup>
                    <FormControlLabel
                      onChange={() => {
                        setSendToAllTeachers(!sendToAllTeachers);
                        setSenderMailIds([]);
                        setToMail("");
                      }}
                      control={<Checkbox checked={sendToAllTeachers} />}
                      label="Send to all teachers"
                    />
                  </FormGroup>
                </Box>
                <Box className='suggestions' style={{ marginTop: "0" }} sx={toMail !== "" ? { display: "flex", marginTop: "0" } : { display: "none" }}>
                  <Typography variant="caption" color="textSecondary">Suggestions:</Typography>
                  <div className='suggestionsMail'>
                    {suggestMail.map((suggestion) => (
                      <Chip
                        key={suggestion.email}
                        label={suggestion.email}
                        onClick={() => {
                          setSenderMailIds(prevState => {
                            return [...prevState, { emails: suggestion.email }]
                          });
                          setSuggestMail([]);
                          setError(prevState => ({ ...prevState, toError: false }))
                          setToMail("");
                        }}
                        sx={{ cursor: "pointer", marginY: "2px" }}
                      />
                    ))}
                  </div>

                </Box>
                <TextField
                  sx={{ '& legend': { display: 'none' }, '& fieldset': { top: 0 } }}
                  type="text"
                  variant='outlined'
                  size='small'
                  color='primary'
                  name='subject'
                  value={subject}
                  error={error.subjectError}
                  helperText={error.subjectError && "Subject should not exceed more than 30 characters"}
                  onChange={(e) => {
                    if (e.target.value.length > 30) {
                      setError(prevState => ({ ...prevState, subjectError: true }))
                      setSubject(e.target.value)
                    } else {
                      setError(prevState => ({ ...prevState, subjectError: false }))
                      setSubject(e.target.value)
                    }
                  }}
                  InputProps={{ startAdornment: <InputAdornment position='start'>Subject : </InputAdornment> }}
                />

                <TextField
                  sx={{ '& legend': { display: 'none' }, '& fieldset': { top: 0 } }}
                  fullWidth
                  placeholder='Type here...'
                  variant='outlined'
                  size='small'
                  color='primary'
                  error={error.messageError}
                  helperText={error.messageError && "Message body should not exceed more than 200 characters"}
                  value={message}
                  onChange={(e) => {
                    if (e.target.value.length > 200) {
                      setError(prevState => ({ ...prevState, messageError: true }))
                      setMessage(e.target.value)
                    } else {
                      setError(prevState => ({ ...prevState, messageError: false }))
                      setMessage(e.target.value)
                    }
                  }}
                  multiline
                  rows={5}
                />
              </>}
            {announcementType === "notification" &&
              <>
                <TextField
                  sx={{ '& legend': { display: 'none' }, '& fieldset': { top: 0 } }}
                  type="text"
                  variant='outlined'
                  size='small'
                  color='primary'
                  name='subject'
                  value={subject}
                  error={error.subjectError}
                  helperText={error.subjectError && "Subject should not exceed more than 30 characters"}
                  onChange={(e) => {
                    if (e.target.value.length > 30) {
                      setError(prevState => ({ ...prevState, subjectError: true }))
                      setSubject(e.target.value)
                    } else {
                      setError(prevState => ({ ...prevState, subjectError: false }))
                      setSubject(e.target.value)
                    }
                  }}
                  InputProps={{ startAdornment: <InputAdornment position='start'>Subject : </InputAdornment> }}
                />

                <TextField
                  sx={{ '& legend': { display: 'none' }, '& fieldset': { top: 0 } }}
                  fullWidth
                  placeholder='Type here...'
                  variant='outlined'
                  size='small'
                  color='primary'
                  error={error.messageError}
                  helperText={error.messageError && "Message body should not exceed more than 200 characters"}
                  value={message}
                  onChange={(e) => {
                    if (e.target.value.length > 200) {
                      setError(prevState => ({ ...prevState, messageError: true }))
                      setMessage(e.target.value)
                    } else {
                      setError(prevState => ({ ...prevState, messageError: false }))
                      setMessage(e.target.value)
                    }
                  }}
                  multiline
                  rows={5}
                />
              </>

            }
            <LoadingButton
              type="button"
              variant='contained'
              loading={loading}
              onClick={sendAnnouncement}
            >
              Send
            </LoadingButton>
          </Stack>
        </Box>
      </Modal>
      {unRegisterEmail && < UnRegisterEmails open={unRegisterEmail} onClose={() => setUnRegisterEmail(false)} setSentUnRegisterEmail={setSentUnRegisterEmail} />}
    </>
  )
}
